export const environment = {
    production: false,
    testing: true,
    apiUrl: '/api', // URL relativa para testing en server2
    torreControlTokenUrl: 'https://opbs.opb.cl/torrecontrol/api/auth/token',
    torreControlApiKey: '6x6pltlv7kRfAz453qAkoF8BeC-FlO-gPGg5mbzFkMs',
    useMocksInstructivoEmbarque: false,
};
